import React,{Component} from 'react';
import {TextField,Typography,Button,Input,
    Table,TableHead,TableBody,TableCell,TableRow
} from '@material-ui/core';



export default class SubirComprobantes extends Component{
    constructor(props){
        super(props);
        this.state={
            archivos:[],
            subiendo:false,
            actualsubiendo:null,
            

        }
    }

    enviarArchivo(fun){
        var request = new XMLHttpRequest();
        request.onreadystatechange = function(){
            if(this.readyState === 4 && this.status === 200){

                if(this.responseText.length > 0){
                    fun(JSON.parse(this.responseText));
                }
            }
        }
        request.open('POST','https://serweb.presidenteperon.gov.ar/provret/comprobantes/subir',true);
    
        let form  = new FormData();
        let actual = this.state.archivos[ this.state.actualsubiendo ]
        form.append(
            'file',
            actual.archivo,
            actual.nombre)
        
        request.send(form);
        
    }

    recibirRespuesta(data){
        
        let archivos = this.state.archivos;
        let actual = this.state.actualsubiendo;
        archivos[actual].estado = data.estado;
        this.setState({archivos:archivos},
            this.state.subiendo === true ? 
                this.subirArchivos.bind(this)():
                null)
    }

    saltarArchivo(){
        let actual = this.state.actualsubiendo;
        let listado = this.state.archivos;
        listado[actual].estado = 'No Subido';
        this.subirArchivos.bind(this)();
    }

    subirArchivos(){

        let actual = this.state.actualsubiendo;

        if(actual === null){
            actual = 0;
        }
        else{
            actual += 1;
        }

        if(actual >= this.state.archivos.length){
            this.setState({
                subiendo:false,
                actualsubiendo:null
            })
            return;
        }

        this.setState({
            subiendo:true,
            actualsubiendo:actual
        },()=>
            this.state.archivos[actual].valido ?
            this.enviarArchivo.bind(this)(this.recibirRespuesta.bind(this)):
            this.saltarArchivo.bind(this)()
            )

        
    }

    validar(archivo){
        let nombre = archivo.name;
        let repa = nombre.substring(0,4);
        if (repa.toLowerCase() !== 'repa'){
            return {resultado:false};
        }
        let numero = nombre.split(' ')[0].substring(4)
        if( isNaN(parseInt(numero)) ){
            return {resultado:false};
        } 

        let anio = nombre.split(' ')[1]
        if( isNaN(parseInt(anio)) ){
            return {resultado:false};
        }

        numero = parseInt(numero)
        if (numero <= 0){
            return {resultado:false};
        }

        anio = parseInt(anio)
        if (anio < 1 || anio > 99){
            return {resultado:false};
        }

        return {
            resultado:true,
            anio:anio,
            numero:numero,
        }



    }


    seleccionarArchivos(lista){
        let final = [];
        for (let x = 0; x < lista.length; x++){
            let conversion = this.validar(lista[x])
            final.push({
                archivo:lista[x],
                nombre:lista[x].name,
                estado:'Pendiente',
                valido:conversion.resultado,
                numero:conversion.numero,
                anio:conversion.anio
            })
        }

        this.setState({
            archivos:final
        })
    }

    render(){
        return(<div>
            <Typography> Subida de Archivos</Typography>
            <div>
                
                <input
                    id='seleccion-archivos'
                    type='file' multiple 
                    onChange={(ev)=>this.seleccionarArchivos.bind(this)(ev.target.files)}
                    style={{display:"none"}}
                ></input>
                <label htmlFor="seleccion-archivos">
                    <Button component='span' variant='contained'
                        color='primary'
                        disabled={this.state.subiendo}
                    >
                        Seleccionar Archivos
                    </Button>
                </label>
                
            </div>
            <div>
                {this.state.archivos.length === 0 ? null :
                    <div>
                        <Typography>Archivos seleccionados</Typography>

                        
                        <Table size='small' style={{width:'80wv'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        Archivo
                                    </TableCell>
                                    <TableCell>
                                        Valido
                                    </TableCell>
                                    <TableCell>
                                        Estado
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.archivos.map((elem,ind)=><TableRow>
                                    <TableCell>
                                        {elem.nombre}
                                    </TableCell>
                                    <TableCell>
                                        {elem.valido? 'Archivo Válido': 'Archivo no Válido'}
                                    </TableCell>
                                    <TableCell>
                                        {elem.estado}
                                    </TableCell>
                                </TableRow>)}
                            </TableBody>
                        </Table>
                        <Button onClick={this.subirArchivos.bind(this)}
                            variant='contained'
                            color='primary' style={{marginTop:'10px'}}
                            disabled={this.state.subiendo}
                        >Subir Archivos</Button>
                    </div>
                    
                }
            </div>
        </div>)
    }
}